export enum FinanceTypeenum {
    FIXED_COST = 'FIXED COST',
    MANUFACTURING_COST = 'MANUFACTURING COST',
    SALE_COST = 'SALE COST',
    PACK_MATERIAL_COST = 'PACK MATERIAL COST',
    RM_COST = 'RM COST'

}